// extracted by mini-css-extract-plugin
module.exports = {"caretWrapper":"regulatoryFees_caretWrapper__lnd7f","upCaret":"regulatoryFees_upCaret__6RSoT","expandedSection":"regulatoryFees_expandedSection__fdoim"};